import { noop } from '@src/utils/common-util';
import BaseModalStore from '@src/components/modal-container/base-modal-store';
import $$tracker from '@src/tracker';

class PhoneBindingModalStore extends BaseModalStore {
  closeCallback = noop;

  constructor(options = {}) {
    super(options);
    Object.assign(this, options);
  }

  onBindPhoneClick = () => {
    $$tracker.clickBindPhone();
  };

  onHaveBoundPhoneClick = () => {
    $$tracker.clickHaveBindPhone();
    this.onClickClose();
  };

  onClickClose = () => {
    this.isOpen = false;
    this.isActive = false;
    this.closeCallback();
    this.clearStyle();
  };
}

export default PhoneBindingModalStore;
